import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function GetProjectTemplateCategoryListById(id) {
    return axios.get(`${APP_SETTINGS.API_PATH.PROJECT_TEMPLATES.GetProjectTemplateCategoryListById}?id=${id}`)
}
export function GetProjectTemplateBoardDetailsById(id) {
    return axios.get(`${APP_SETTINGS.API_PATH.PROJECT_TEMPLATES.GetProjectTemplateBoardDetailsById}?id=${id}`)
}